import {
  IGeneralPetCareItem,
  IGetGeneralPetCareResponse,
} from "../../services/Standard-of-care/standard-of-care.interface";
import { IPrescriptionResponse } from "../../services/prescription/prescription.interface";

export const actionTypes = {
  SET_PET_CARE_DATA: "SET_PET_CARE_DATA",
  UPDATE_FULFILLED_MONTH_STATUS: "UPDATE_FULFILLED_MONTH_STATUS",
  SET_SELECTED_PRESCRIPTION: "SET_SELECTED_PRESCRIPTION",
  SET_SELECTED_PET: "SET_SELECTED_PET",
};

const setPetCareData = (payload: IGetGeneralPetCareResponse | undefined) => ({
  type: actionTypes.SET_PET_CARE_DATA,
  payload,
});

const updateFulfilledMonthStatus = (petId: string, updatePetData: IGeneralPetCareItem) => ({
  type: actionTypes.UPDATE_FULFILLED_MONTH_STATUS,
  payload: { petId, updatePetData },
});

const setSelectedPrescription = (payload: IPrescriptionResponse | null) => ({
  type: actionTypes.SET_SELECTED_PRESCRIPTION,
  payload,
});

const setSelectedPet = (payload?: IGeneralPetCareItem) => ({
  type: actionTypes.SET_SELECTED_PET,
  payload,
});

export default {
  setPetCareData,
  updateFulfilledMonthStatus,
  setSelectedPrescription,
  setSelectedPet,
};
